export enum ButtonVariant {
    Normal = 'Normal',
    Outline = 'Outline',
    Text = 'Text',
    Secondary = 'Secondary',
    Cancel = 'Cancel',
}
